import { COMPOSITION_END_THRESHOLD_MS, IME_PROCESS_KEY_CODE } from '$lib/constants';

class CompositionStore {
	lastCompositionEnd = $state<number | undefined>(undefined);

	/**
	 * Records IME `compositionend` timestamps window-wide.
	 * @returns a function that stops tracking
	 */
	track(): () => void {
		const record = (evt: CompositionEvent) => {
			this.lastCompositionEnd = evt.timeStamp;
		};
		window.addEventListener('compositionend', record, { capture: true });
		return () => window.removeEventListener('compositionend', record, { capture: true });
	}

	/**
	 * Some browsers fire the Enter keydown that finishes an IME composition with
	 * `isComposing === false`; the recent `compositionend` timestamp catches that case.
	 * @param evt - keydown event
	 * @param threshold - how recent a `compositionend` still counts, in ms
	 * @returns whether `evt` belongs to an IME composition
	 */
	isComposing(evt: KeyboardEvent, threshold = COMPOSITION_END_THRESHOLD_MS): boolean {
		return (
			evt.isComposing ||
			(evt.keyCode === IME_PROCESS_KEY_CODE &&
				this.lastCompositionEnd !== undefined &&
				evt.timeStamp - this.lastCompositionEnd < threshold)
		);
	}
}

export const compositionStore = new CompositionStore();
